import styled from 'styled-components';

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.lighterBackground};
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  padding: 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: all 0.2s ease-in-out;

  & + & {
    margin-top: 16px;
  }

  .info {
    .card-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      strong {
        font-size: 16px;
        color: ${({ theme }) => theme.colors.gray[900]};
      }

      button {
        background: ${({ theme }) => theme.colors.primary.main};
        color: ${({ theme }) => theme.colors.lighterBackground};
        border: none;
        padding: 6px 12px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.2s ease-in;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    span {
      display: block;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.gray[200]};
      margin-bottom: 8px;

      strong {
        color: ${({ theme }) => theme.colors.gray[900]};
        font-weight: 600;
      }
    }

    .rating-stars {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid ${({ theme }) => theme.colors.gray[100]};

      .rating-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.gray[900]};

        span {
          margin: 0;
          font-size: 12px;
          color: ${({ theme }) => theme.colors.gray[200]};
        }
      }
    }
  }
`;
